import React from "react";
import { useParams, Link } from "react-router-dom";
import fastwash from "../assets/images/Produits/WashBasic.jpg";
import fastwashpro from "../assets/images/Pro.png";
import letsShowerImage from "../assets/images/Produits/letshower.png";
import fastwashallinone from "../assets/images/AllinOne.png";
import aspirateur from "../assets/images/Produits/Aspirateur (2).png";
import gonfleur from "../assets/images/Gonfleur2.png";
import destributeur from "../assets/images/Distributeur.png";
import recyclage from "../assets/images/recycliqu.jpg";
import machine from "../assets/images/machinelaver.png";
import sech from "../assets/images/secheur.png";
import frappeTapis from "../assets/images/FrappeT.png";

const ProductDetails: React.FC = () => {
  const { id } = useParams();

  const products: any = {
    fastwashbasic: {
      title: "Fast Wash Basic",
      image: fastwash,
      description: `
Le Fast Wash Basic est un système de lavage automobile conçu pour offrir une performance rapide, efficace et adaptée aux stations de lavage modernes.

Il permet un nettoyage complet des véhicules grâce à une combinaison de jets haute pression et de programmes optimisés pour éliminer la saleté, la poussière et les résidus tenaces sur la carrosserie.

Conçu pour un usage intensif, il garantit une grande fiabilité, une consommation d’eau maîtrisée et une excellente durabilité même dans des environnements à forte activité.

Son interface simple et intuitive permet une utilisation facile aussi bien pour les opérateurs que pour les clients.

Le Fast Wash Basic représente une solution idéale pour les centres de lavage recherchant efficacité, rapidité et rentabilité.
      `,
    },

    fastwashpro: {
      title: "Fast Wash Pro",
      image: fastwashpro,
      description: `
Le Fast Wash Pro est un système de lavage automobile avancé conçu pour offrir des performances supérieures et une qualité de nettoyage optimale.

Grâce à une technologie plus poussée, il permet un lavage plus précis, plus rapide et adapté aux environnements à forte exigence opérationnelle.

Sa conception robuste garantit une excellente durabilité ainsi qu’une fiabilité renforcée, même en utilisation intensive continue.

Optimisé pour les stations de lavage modernes, il offre une gestion intelligente des cycles et une meilleure efficacité énergétique.

Le Fast Wash Pro représente une solution idéale pour les centres de lavage recherchant puissance, productivité et haut niveau de performance.
      `,
    },
    letsshower: {
  title: "Let's Shower",
  image: letsShowerImage,
  description: `
Let’s Shower est un système de lavage self-service conçu pour permettre un nettoyage extérieur des véhicules de manière simple, autonome et efficace.

Il met à disposition de l’utilisateur différents équipements de rinçage et de nettoyage permettant d’éliminer la poussière, la saleté et les résidus de la carrosserie.

Grâce à son interface intuitive et à son fonctionnement flexible, l’utilisateur contrôle entièrement le processus de lavage selon ses besoins.
  `,},
  fastwashallinone: {
  title: "Fast Wash All-in-One",
  image: fastwashallinone,
  description: `
Le Fast Wash All-in-One est une solution polyvalente conçue pour regrouper plusieurs fonctionnalités essentielles au sein d’un seul équipement.

Pensé pour optimiser l’espace et simplifier l’expérience utilisateur, il permet d’accéder à différents programmes et services à partir d’une interface unique, intuitive et facile à utiliser.

Sa conception moderne favorise une gestion centralisée des opérations tout en offrant une grande flexibilité d’utilisation. Grâce à son architecture intégrée, il réduit les besoins en équipements complémentaires et facilite l’installation ainsi que la maintenance.

Robuste et conçu pour une utilisation intensive, le Fast Wash All-in-One garantit des performances constantes, une excellente fiabilité et une expérience utilisateur fluide.

Le Fast Wash All-in-One représente une solution idéale pour les exploitants recherchant un équipement complet, pratique et performant capable de répondre efficacement aux besoins quotidiens de leurs clients.
`,
},
aspirateurselfservice: {
  title: "Aspirateur",
  image: aspirateur, // 
  description: `
L’Aspirateur Self Service est un équipement conçu pour assurer le nettoyage intérieur des véhicules de manière simple, rapide et efficace.

Doté d’une puissance d’aspiration élevée, il permet d’éliminer efficacement la poussière, le sable, les miettes et autres saletés présentes dans l’habitacle du véhicule.

Sa conception robuste lui permet de fonctionner de manière fiable dans des environnements à forte fréquentation tout en nécessitant un entretien réduit.

Facile à utiliser, il offre aux utilisateurs une solution pratique pour compléter le lavage extérieur de leur véhicule et obtenir un résultat de propreté optimal.

L’Aspirateur Self Service constitue un équipement indispensable pour améliorer l’expérience des utilisateurs et enrichir les services proposés sur les espaces dédiés à l’entretien automobile.
  `,
},
gonfleurairselfservice: {
  title: "Gonfleur Air ",
  image: gonfleur, // vérifier import
  description: `
Le Gonfleur Air Self Service est un équipement essentiel permettant aux automobilistes de vérifier et ajuster facilement la pression de leurs pneus.

Fiable et simple d’utilisation, il garantit un gonflage précis afin d’assurer une meilleure sécurité de conduite et une durée de vie optimale des pneus.

Conçu pour un usage en libre-service, il fonctionne de manière autonome et s’intègre parfaitement dans les stations de lavage et les espaces d’entretien automobile.

Robuste et résistant aux conditions extérieures, il offre une disponibilité continue et une utilisation intuitive pour tous les utilisateurs.

Le Gonfleur Air Self Service constitue une solution indispensable pour améliorer la sécurité et le confort des conducteurs tout en enrichissant les services proposés sur les stations modernes.
  `,
},
distributeureauessuieglace: {
  title: "Distributeur d'Eau d'Essuie-Glace",
  image: destributeur, // ton image déjà importée
  description: `
Le Distributeur d’Eau d’Essuie-Glace est un équipement conçu pour permettre aux automobilistes de nettoyer rapidement leur pare-brise.

Il fournit une solution pratique et accessible pour éliminer les saletés, la poussière et les traces gênantes afin d’assurer une visibilité optimale.

Facile à utiliser et totalement autonome, il s’intègre parfaitement dans les stations de service et les espaces de lavage automobile.

Robuste et conçu pour un usage extérieur, il garantit une disponibilité continue et une utilisation simple pour tous les utilisateurs.

Cet équipement contribue à améliorer la sécurité routière et l’expérience utilisateur dans les stations modernes.
  `,
},
recyclageeau: {
  title: "Système de Recyclage d'Eau",
  image: recyclage,
  description: `
Le Système de Recyclage d’Eau est une solution écologique conçue pour optimiser la gestion de l’eau dans les stations de lavage.

Il permet de filtrer, traiter et réutiliser l’eau utilisée lors des cycles de lavage, réduisant ainsi considérablement le gaspillage.

Grâce à sa technologie de recyclage, il contribue à la protection de l’environnement tout en maintenant une excellente qualité de nettoyage.

Facile à intégrer dans les installations existantes, il fonctionne de manière autonome et fiable.

Ce système représente une solution durable et essentielle pour les stations modernes soucieuses de leur impact environnemental.
  `,
},
machinealaverprofessionnelle: {
  title: "Machine à Laver Professionnelle",
  image: machine,
  description: `
La machine à laver est conçue pour répondre aux besoins des projets de laverie self-service modernes.

Elle permet un lavage efficace, rapide et homogène grâce à des programmes optimisés pour différents types de textiles et de charges.

Grâce à sa grande capacité, elle est idéale pour traiter des volumes importants de linge tout en garantissant une consommation d’eau et d’énergie maîtrisée.

Sa conception robuste assure une utilisation intensive et une fiabilité sur le long terme, même dans des environnements à forte activité.

Cette solution représente un choix essentiel pour les stations de laverie self-service cherchant performance, durabilité et simplicité d’utilisation.
  `,
},
sechelingeprofessionnel: {
  title: "Sèche-Linge ",
  image: sech,
  description: `
Le sèche-linge garantit un séchage rapide et homogène pour de grandes quantités de linge.

Il est spécialement conçu pour les laveries self-service à forte activité.

Sa technologie assure une performance constante tout en respectant les textiles.

Sa grande capacité permet un gain de temps important dans le processus de lavage.

C’est un équipement essentiel pour compléter une station de laverie moderne.
  `,
},
frappetapis: {
  title: "Frappe Tapis Self Service",
  image: frappeTapis,
  description: `
Le Frappe Tapis est un équipement conçu pour le nettoyage en profondeur des tapis de voiture.

Facile à utiliser, il offre une solution rapide et autonome pour les stations de lavage modernes.

Robuste et adapté à un usage intensif, il garantit une excellente durabilité et une efficacité constante.

Cet équipement améliore l’expérience client en complétant parfaitement les services de lavage automobile.
  `,
},
  };

  const product = products[id || ""];

  if (!product) {
    return (
<div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 sm:px-6">        <div className="text-center">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-blue-50">
            <svg className="w-8 h-8 text-blue-600" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
              <path d="M12 8V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              <circle cx="12" cy="16" r="0.9" fill="currentColor" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Produit introuvable</h1>
          <p className="text-gray-500 mb-6">Ce produit n’existe pas ou n’est plus disponible.</p>
          <Link
            to="/produits"
            className="inline-flex items-center gap-2 rounded-full bg-blue-600 px-6 py-2.5 text-sm font-semibold text-white hover:bg-blue-700 transition-colors"
          >
            Retour aux produits
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">

      {/* HERO */}
<div className="relative bg-gradient-to-br from-blue-700 via-blue-700 to-blue-900 pt-28 sm:pt-32 md:pt-36 pb-16 sm:pb-20 md:pb-24 px-4 sm:px-6 overflow-hidden">
          <span className="pointer-events-none select-none absolute -bottom-12 left-1/2 -translate-x-1/2 text-[18vw] sm:text-[6rem] md:text-[7rem] font-black text-white/5 leading-none tracking-tight whitespace-nowrap">
          J-TRONICS
        </span>

        <div className="relative z-10 max-w-5xl mx-auto">
          <Link
            to="/produits"
        className="inline-flex items-center gap-2 text-blue-100/80 hover:text-yellow-400 text-xs sm:text-sm font-medium mb-6 transition-colors"
          >
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 12H5M5 12L11 6M5 12L11 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Retour aux produits
          </Link>

          <span className="inline-flex items-center gap-2 text-yellow-400 text-xs font-bold tracking-[0.25em] uppercase mb-4">
            <span className="w-8 h-px bg-yellow-400"></span>
            Fiche produit
          </span>

<h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white">
              {product.title}
          </h1>
        </div>
      </div>

      {/* CONTENT */}
<div className="max-w-6xl mx-auto px-4 sm:px-6 -mt-10 sm:-mt-12 pb-16 sm:pb-24">
<div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] gap-6 sm:gap-8 lg:gap-10 items-start">
          {/* IMAGE CARD */}
          <div className="relative bg-white rounded-3xl shadow-2xl shadow-blue-900/10 border border-gray-100 overflow-hidden">
            <div className="absolute top-0 left-0 h-1.5 w-full bg-gradient-to-r from-blue-600 to-yellow-400"></div>
<div className="flex items-center justify-center p-4 sm:p-8 md:p-10 h-[220px] sm:h-[320px] md:h-[420px]">
                <img
                src={product.image}
                alt={product.title}
                className="max-h-full max-w-full object-contain"
              />
            </div>
          </div>

          {/* TEXT CARD */}
<div className="bg-white rounded-3xl shadow-md border border-gray-100 p-5 sm:p-8 lg:p-9 mt-4 sm:mt-6">
          <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-xl bg-yellow-400 flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 text-blue-900" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 17H15M9 13H15M9 9H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <rect x="5" y="3" width="14" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
                </svg>
              </div>
              <h2 className="text-sm font-bold uppercase tracking-wide text-blue-700">
                Présentation
              </h2>
            </div>

<p className="text-gray-600 text-sm sm:text-base leading-relaxed whitespace-pre-line">
                {product.description}
            </p>

          </div>

        </div>
      </div>
    </div>
  );
};

export default ProductDetails;